import { gql } from '@apollo/client';
export const getContactFromTicket = ticket => {
  const contact = ticket.associations.ticketToContact.edges[0];
  return contact ? contact.node : null;
};
export const getCompanyFromContact = contact => contact.associations.contactToCompany;
export const TicketToContactAssociationFragment = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"TicketToContactAssociationFragment\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"CrmObject\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Ticket\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associations\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"ticketToContact\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"first\"},\"value\":{\"kind\":\"IntValue\",\"value\":\"50\"}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"edges\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"node\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"defaultProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_is_contact\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"email\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"firstname\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"lastname\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_all_contact_vids\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"phone\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associations\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"contactToCompany\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"defaultProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}", {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "TicketToContactAssociationFragment"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "CrmObject"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "InlineFragment",
        typeCondition: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Ticket"
          }
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "associations"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "ticketToContact"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "first"
                  },
                  value: {
                    kind: "IntValue",
                    value: "50"
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "edges"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "node"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "id"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "defaultProperties"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "hs_is_contact"
                                },
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "id"
                                    }
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "value"
                                    }
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "email"
                                },
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "id"
                                    }
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "value"
                                    }
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "firstname"
                                },
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "id"
                                    }
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "value"
                                    }
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "lastname"
                                },
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "id"
                                    }
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "value"
                                    }
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "hs_all_contact_vids"
                                },
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "id"
                                    }
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "value"
                                    }
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "phone"
                                },
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "id"
                                    }
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "value"
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "associations"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "contactToCompany"
                                },
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "id"
                                    }
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "defaultProperties"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{
                                        kind: "Field",
                                        name: {
                                          kind: "Name",
                                          value: "name"
                                        },
                                        selectionSet: {
                                          kind: "SelectionSet",
                                          selections: [{
                                            kind: "Field",
                                            name: {
                                              kind: "Name",
                                              value: "id"
                                            }
                                          }, {
                                            kind: "Field",
                                            name: {
                                              kind: "Name",
                                              value: "value"
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});